import Injection = EECore.Injection;
import InstabilityMessageModel from "../entities/instabilityMessages/instabilityMessageModel";
import ContentServiceHelper from "../../../../Core/src/helpers/contentServiceHelper";

@Injection.injectableClass("InstabilityMessagesService")
export default class InstabilityMessagesService {

  @Injection.injectableProperty("InstabilityMessagesService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  @Injection.injectableProperty("InstabilityMessagesService", EECore.Registrations.CONTENT_SERVICE_HELPER)
  private contentServiceHelper: ContentServiceHelper;

  @Injection.injectableProperty("InstabilityMessagesService", EECore.Registrations.AUTH_SERVICE)
  private authService: EECore.Services.AuthService;

  constructor(httpClient: EECore.HttpClient, contentServiceHelper: ContentServiceHelper, authService: EECore.Services.AuthService) {
    this.httpClient = httpClient;
    this.contentServiceHelper = contentServiceHelper;
    this.authService = authService;
  }

  getInstabilityMessages(applicationName = ""): EECore.Promise<string[], string> {
    return new EECore.Promise<string[], string>((resolve, reject) => {
      const lobCode = this.contentServiceHelper.getLobCode();
      const request = this.httpClient.get<InstabilityMessageModel[]>(this.getApiRoute(lobCode, applicationName), true);             
      request.then((messages: InstabilityMessageModel[]) => {
        const userIsAuthenticated = this.authService.isAuthenticated();
        const ret = [];
        for (let i = 0; i < messages.length; i++) {
          const item = messages[i];
          if (item.authenticated === true && item.notAuthenticated === true ||
                        !item.authenticated && !item.notAuthenticated) {
            ret.push(item.message);
          } else {
            if (userIsAuthenticated) {
              if (item.authenticated === true) {
                ret.push(item.message);
              }
            } else {
              if (item.notAuthenticated === true) {
                ret.push(item.message);
              }
            }
          }
        }
        resolve(ret);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  private getApiRoute(lobCode = "", applicationName = ""): string {
    let routeAPI = "/cw/api/instabilitymessages"; 
    let params = "";

    if (lobCode) params += `lobCode=${lobCode}`;
    if (lobCode && applicationName) params += "&";
    if (applicationName) params += `applicationName=${applicationName}`;

    if (params) routeAPI += `?${params}`;
        
    return routeAPI;
  }

}